<template>
  <div
    class="tw-inline-block"
    v-tooltip="isCoachingAlreadyRequested ? 'Coaching already requested' : ''"
  >
    <BaseButton
      @click="openModal('request-coaching')"
      :is-disabled="isCoachingAlreadyRequested"
      is-block
      test_id="request-coaching-button"
    >
      <CoachingIcon class="tw-mr-2 tw-h-4 tw-w-4" />
      Request Coaching
    </BaseButton>

    <FormModal
      name="request-coaching"
      header="Mentor Coaching"
      icon-color="green"
    >
      <template #icon>
        <CoachingIcon />
      </template>
      <template #default>
        <FormModalBody
          :is-button-disabled="
            hasObjectPermissions(
              $page.props.mentor,
              OBJECT_PERMISSIONS.MENTORS.OWNER,
            )
          "
          :is-button-loading="isLoading"
          footer-button-text="I would like to purchase coaching"
          @submit="requestCoaching"
        >
          <div>
            <div>
              <h4 class="tw-heading-4">Coaching details</h4>
              <!--The prettier-ignore is only for strange whitespace formatting.-->
              <!-- prettier-ignore -->
              <p
                class="
                tw-text-neutral-500
                tw-mt-1
                tw-text-break
                tw-whitespace-pre-line
                tw-text-break
              "
              >{{ description || 'Description not provided.' }}</p>
            </div>
            <div class="tw-mt-4">
              <h4 class="tw-heading-4">Cost</h4>
              <p class="tw-mt-1 tw-text-neutral-500">
                {{ cost ? `${cost} / per month` : 'Not specified.' }}
              </p>
            </div>
          </div>
        </FormModalBody>
      </template>
    </FormModal>
  </div>
</template>

<script setup>
import BaseButton from '@/shared/components/BaseButton.vue'
import FormModal from '@/shared/components/modals/FormModal/FormModal.vue'
import FormModalBody from '@/shared/components/modals/FormModal/FormModalBody.vue'
import CoachingIcon from '@/assets/images/icons/coaching.svg'
import {
  ACCESS_TYPE,
  OBJECT_PERMISSIONS,
} from '@/shared/data/permissionSystem.js'
import { ref } from 'vue'
import { usePage } from '@inertiajs/vue3'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'
import axios from 'axios'
import { useModals } from '@/shared/composables/useModals.js'

const props = defineProps({
  description: {
    type: String,
    default: '',
  },
  url: {
    type: String,
    required: true,
  },
  cost: {
    type: String,
    default: '',
  },
})

const page = usePage()
const { hasAccess, hasObjectPermissions } = usePermissionSystem()
const { closeModal, openModal } = useModals()

const isCoachingAlreadyRequested = ref(page.props.coachingRequested)
const isLoading = ref(false)

const requestCoaching = async () => {
  if (hasAccess(ACCESS_TYPE.GROWTHMENTOR)) {
    isLoading.value = true
    await axios.post(props.url)
    isLoading.value = false
    isCoachingAlreadyRequested.value = true
    closeModal('request-coaching')
  } else {
    window.open('/upgrade_plan/new')
  }
}
</script>
